var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload",
    clipPath: "url(#clip0_21_3720)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 5.62349V17C13.5 17.8297 12.8297 18.5 12 18.5C11.1703 18.5 10.5 17.8297 10.5 17V5.62349L7.05938 9.06411C6.47344 9.65005 5.52188 9.65005 4.93594 9.06411C4.35 8.47817 4.35 7.52661 4.93594 6.94067L10.9359 0.940674C11.5219 0.354736 12.4734 0.354736 13.0594 0.940674L19.0594 6.94067C19.6453 7.52661 19.6453 8.47817 19.0594 9.06411C18.4734 9.65005 17.5219 9.65005 16.9359 9.06411L13.5 5.62349ZM3 17H9C9 18.6547 10.3453 20 12 20C13.6547 20 15 18.6547 15 17H21C22.6547 17 24 18.3454 24 20V21.5C24 23.1547 22.6547 24.5 21 24.5H3C1.34531 24.5 0 23.1547 0 21.5V20C0 18.3454 1.34531 17 3 17ZM20.25 21.875C20.5484 21.875 20.8345 21.7565 21.0455 21.5455C21.2565 21.3346 21.375 21.0484 21.375 20.75C21.375 20.4517 21.2565 20.1655 21.0455 19.9546C20.8345 19.7436 20.5484 19.625 20.25 19.625C19.9516 19.625 19.6655 19.7436 19.4545 19.9546C19.2435 20.1655 19.125 20.4517 19.125 20.75C19.125 21.0484 19.2435 21.3346 19.4545 21.5455C19.6655 21.7565 19.9516 21.875 20.25 21.875Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_3720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e9a85d26f3559b1087fd4963fc161b1f.svg";
export { ForwardRef as ReactComponent };